import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';

interface ImageModalProps {
  imageUrl: string;
  description?: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ imageUrl, description, isOpen, setIsOpen }) => {
  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: 'background.default',
          backgroundImage: 'none',
          borderRadius: '16px',
        },
      }}
    >
      <DialogTitle
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Tooltip title={description}>
          <Typography
            sx={{
              fontSize: '1.5rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flexGrow: 1,
              marginRight: '1rem',
            }}
          >
            {description}
          </Typography>
        </Tooltip>
        <IconButton onClick={onClose} color="secondary">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: 0,
          maxHeight: '90vh',
        }}
      >
        <img
          src={imageUrl}
          alt="imagem-ativo"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;
